import { render, staticRenderFns } from "./modal-alterar-senha.vue?vue&type=template&id=b249bfe0"
import script from "./modal-alterar-senha.vue?vue&type=script&lang=js"
export * from "./modal-alterar-senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports